import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeaderContentModule } from '../../notes/header-content/header-content.module';
import { HeaderContentGridComponent } from './header-content-grid.component';

@NgModule({
  declarations: [HeaderContentGridComponent],
  imports: [CommonModule, HeaderContentModule],
  exports: [HeaderContentGridComponent],
})
export class HeaderContentGridModule {}
